import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import PropTypes from 'prop-types';

import { getEnvironment } from '../../../../shared/utils/helpers';

const mutation = graphql`
  mutation AddSolicitationDeliverableMutation($input: AddSolicitationDeliverableInput!) {
    addSolicitationDeliverable(input: $input) {
      isUpdated
      solicitation {
        id
        numberOfDeliverables
        totalDeliverableAmount
      }
    }
  }
`;

const AddSolicitationDeliverableMutation = (solicitationId, deliverableId, callback) => {
  const addSolicitationDeliverableVariables = {
    input: { solicitationId, deliverableId }
  };

  const config = {
    mutation,
    variables: addSolicitationDeliverableVariables,
    onCompleted: response => {
      callback(response.addSolicitationDeliverable);
    }
  };

  commitMutation(getEnvironment(), config);
};

export default AddSolicitationDeliverableMutation;

AddSolicitationDeliverableMutation.propTypes = {
  solicitationId: PropTypes.string.isRequired,
  deliverableId: PropTypes.string.isRequired
};
